var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSpinner = function SvgSpinner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "spinner_svg__a",
    x1: 26.4,
    x2: 10.93,
    y1: 31.59,
    y2: 3.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00ACE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#00ACE2",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#00ACE2",
    stopOpacity: 0.67
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#00ACE2",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#00ACE2",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#00ACE2",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#00ACE2",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#00ACE2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "spinner_svg__b",
    x1: 6.75,
    x2: 30.62,
    y1: 20,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#00ACE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#00ACE2",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#00ACE2",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#00ACE2",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#00ACE2",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#00ACE2",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#00ACE2",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#00ACE2",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#00ACE2",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#00ACE2",
    stopOpacity: 0
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#spinner_svg__a)",
    d: "M0 20A20 20 0 0 1 20 0a3 3 0 0 1 0 6 14 14 0 1 0 5 .92V.63A20 20 0 1 1 0 20Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#spinner_svg__b)",
    d: "M0 20A20 20 0 0 1 20 0a3 3 0 0 1 0 6 14 14 0 1 0 5 .92V.63A20 20 0 1 1 0 20Z"
  })));
};
export default SvgSpinner;